<template>
  <div id="atoms" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%">
    <svg id="atomsSvg" viewBox="0 0 1600 900">
      <path
        fill-opacity="0"
        id="atoms_path_1"
        d="m245.837467,614.165442l-245.837467,-190.835272l358.330656,-421.663516c0.839299,0.836684 1230.830124,365.833961 1232.496778,365.833961c1.666654,0 -1326.65677,518.329467 -1327.496068,517.492772c0.839298,0.836694 -260.825417,-189.161888 -261.664712,-189.99858c0.839295,0.836692 749.167046,-690.824815 748.327742,-691.661499c0.839304,0.836684 849.166309,617.498751 848.326995,616.662059c0.839313,0.836691 -314.158337,264.16806 -314.997647,263.331366c0.83931,0.836694 -940.820332,-197.49516 -941.659631,-198.331852c0.839299,0.836692 -95.826647,-70.82944 -95.826647,-70.82944z"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        fill-opacity="0"
        id="atoms_path_2"
        d="m195.83784,707.498079c1.666654,0 1403.322865,-588.328944 1403.322865,-588.328944c0,0 -188.331928,-114.999142 -189.17124,-115.835826c0.839311,0.836684 -1397.483591,235.834931 -1398.322886,234.998244c0.839295,0.836687 1579.160854,429.166825 1578.321541,428.330133c0.839313,0.836692 -595.822902,225.835013 -596.662209,224.998319c0.839306,0.836694 -799.154726,-184.161926 -797.488072,-184.161926z"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        id="atoms_path_3"
        d="m309.170328,565.832469c-1.666654,1.666654 -294.997799,-4.999963 -295.837094,-5.836653c0.839295,0.83669 1569.160929,-177.495313 1568.321616,-178.332001c0.839313,0.836688 -532.490042,-372.49386 -533.329349,-373.330544c0.839307,0.836684 -1020.819738,170.835416 -1021.659033,169.99873c0.839295,0.836686 425.836125,710.83139 424.996825,709.994695c0.8393,0.836694 1135.830833,-309.160993 1134.99152,-309.997684c0.839313,0.836691 -962.486834,-575.825674 -963.326136,-576.662358c0.839302,0.836684 -607.489493,494.166337 -608.328788,493.329647c0.839295,0.83669 295.837094,69.169513 294.17044,70.836168z"
        fill-opacity="0"
        stroke-opacity="null"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        id="atoms_path_4"
        d="m414.169545,552.499235c-106.665871,14.999888 -408.330287,309.997687 -406.663633,309.997687c1.666654,0 66.666169,33.333085 65.826874,32.49639c0.839296,0.836694 1520.827957,-184.161926 1519.988644,-184.998618c0.839313,0.836692 -672.488997,-714.157974 -673.328303,-713.328004c0.839306,-0.82997 -920.820486,155.835528 -919.993126,154.998842c-0.827359,0.836686 889.166002,744.164474 889.166002,744.164474c0,0 704.994741,-418.330213 704.155427,-419.166902c0.839313,0.83669 -1589.148826,-405.826943 -1589.988121,-406.663628c0.839295,0.836685 209.171074,-72.496101 208.331777,-71.666131c0.839297,-0.82997 1207.496963,904.163279 1206.657651,903.326584c0.839311,0.836694 170.838043,-72.496092 169.99873,-73.332785c0.839313,0.836694 -1572.482283,-332.494153 -1174.151921,-275.827909z"
        fill-opacity="0"
        stroke-opacity="null"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        id="atoms_path_5"
        d="m242.504159,784.164174l1347.483962,-515.832845l-414.996899,-264.99802l-1173.324567,576.662358l1133.324866,313.330992l459.996563,-376.663852l-1586.654812,-223.331665l1068.325351,-283.331216l506.662881,163.332113l-1340.817345,610.832136z"
        fill-opacity="0"
        stroke-opacity="null"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        id="atoms_path_6"
        d="m119.171746,692.498191l-114.171783,82.496019c0.839295,0.836693 170.838026,124.169106 172.504681,124.169106c1.666654,0 1354.989892,-893.326669 1354.150579,-894.163353c0.839313,0.836684 69.172136,50.836311 68.332823,49.999626c0.839313,0.836685 -1580.815554,564.165816 -1581.65485,563.329125c0.839296,0.836691 354.169993,270.834677 353.330694,269.997982c0.839299,0.836695 1227.496815,-452.493257 1226.657502,-453.329946c0.839313,0.836689 -1530.815928,-432.493412 -1531.655223,-433.330096c0.839295,0.836684 -74.160145,112.502518 -73.332786,111.665833c-0.827359,0.836685 1605.827322,664.16507 1604.988009,663.328377c0.839313,0.836693 -255.825439,109.169218 -256.664749,108.332524c0.83931,0.836694 -1165.818654,-277.494563 -1166.65795,-278.331254c0.839296,0.836691 -27.493825,34.169776 -28.333122,33.333084c0.839297,0.836692 -0.827357,12.503271 2.505951,25.836505c3.333308,13.333234 -18.333197,29.999776 -29.999776,26.666468z"
        fill-opacity="0"
        stroke-opacity="null"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <path
        id="atoms_path_7"
        d="m367.503226,600.832208c-1.666654,1.666654 -351.664043,-73.332786 -352.503338,-74.169476c0.839295,0.83669 1455.828441,-512.492814 1454.989129,-513.329498c0.839312,0.836684 119.171763,224.168351 118.332449,223.331665c0.839313,0.836687 -1280.817792,657.498455 -1281.657091,656.66176c0.839298,0.836694 -309.158389,-149.162187 -308.33103,-149.998879c-0.827359,0.836693 1597.494051,-195.828507 1595.827397,-195.828507c-1.666654,0 -1579.988214,-189.998583 -1581.654868,-189.998583c-1.666654,0 1579.988214,-208.331779 1579.1489,-209.168465c0.839313,0.836686 -1077.485976,-137.495616 -1078.325277,-138.3323c0.839301,0.836684 -515.823512,254.168128 -514.996152,253.331441c-0.827359,0.836687 769.166897,629.165333 768.327593,628.328639c0.839304,0.836694 827.499804,-575.825671 826.66049,-576.662358c0.839313,0.836688 -897.487319,-305.827691 -898.326622,-306.664375c0.839303,0.836684 -690.822204,429.166822 -691.661499,428.330133c0.839295,0.836689 365.836572,162.50215 364.169918,164.168804z"
        fill-opacity="0"
        stroke-opacity="null"
        stroke-width="1.5"
        stroke="none"
        fill="none"
      />
      <circle
        :r="randomNumber(10, 35)"
        :fill="getRandomColor()"
        v-for="(counter, index) in 10"
        :key="'circle' + counter"
      >
        <animateMotion :dur="30 + index * 3 + 's'" :begin="index / 2 + 's'" repeatCount="indefinite">
          <mpath :xlink:href="'#atoms_path_' + randomNumber(7, 1)" />
        </animateMotion>
        <animate
          attributeName="opacity"
          values="0;0;0.5;0.7;0.7;0;0"
          :begin="0 + 's'"
          :dur="30 + index * 3 + 's'"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: 'atoms',
  props: {
    itemStyle: {
      default: () => {
        return null;
      },
      type: Object,
    },
  },
  methods: {
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="sass">
@import '../../style/base'
@import '../../style/animation'
#atoms
  position: fixed
  #atomsSvg
    position: absolute
    width: 100%
    left: 0
    height: 100%
    //transform-origin: center
</style>
